import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Btn } from '../../AbstractElements';
import { AddPayment, Cancel, Print } from '../../Constant';
import PublicInvoiceDescription from './PublicInvoiceDescription';
import { Col } from 'reactstrap';
import { useReactToPrint } from 'react-to-print';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getInvoiceData, getInvoiceDataRole, getPublicInvoice } from '../../CommonUrl';
import { useSelector } from 'react-redux';
import { getClientUrlDataToken, getDataPublic } from '../../Utils/restUtils';
import Transparentspinner from '../Common/Loader/Transparentspinner';

const PublicInvoice = () => {
    const [spinnerTrans, setspinnerTrans] = useState(true)
    const authState = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [invoiceDetail, setInvoiceDetail] = useState('');
    const location = useLocation();
    const searchParams = location.search;
    const { orderId } = useParams();
    const componentRef = useRef(null);
   

    useEffect(() => {
        invoiceData();
    }, [])

    const invoiceData = async () => {
        const response = await getDataPublic(getPublicInvoice + `?order_id=${orderId}`);
        if (response?.status === true) {
            setInvoiceDetail(response.data);
        } 
        else {
            navigate(`${process.env.PUBLIC_URL}/error`);

        }
        setspinnerTrans(false);

    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            {Object.keys(invoiceDetail).length > 0 && (
                <PublicInvoiceDescription ref={componentRef} invoiceData={invoiceDetail} />
            )}
            <Col sm="12" className="text-center my-3">
                <Btn attrBtn={{ color: 'primary', className: 'me-2', onClick: handlePrint }}>
                    {Print}
                </Btn>
                {/* {status !== 'paid' && (
                    <Link to={`${process.env.PUBLIC_URL}/customers/customer/invoice/invoice-payment-add?invoice_id=${orderId}&customer_id=${paramCustomerId}&invoice_no=${invoiceno}&con_type=${connectionType}&stb_id=${stbNo}`}>
                        <Btn attrBtn={{ color: 'secondary' }}>{AddPayment}</Btn>
                    </Link>
                )} */}
            </Col>
        </Fragment>
    );
};

export default PublicInvoice;